import { io } from 'socket.io-client';

import type { Socket } from 'socket.io-client';

type SearchIndex = 'doctors' | 'medcenters' | 'skills' | 'cities';

interface SocketConfig {
  url: string;
  autoConnect?: boolean;
  reconnection?: boolean;
  reconnectionAttempts?: number;
  reconnectionDelay?: number;
  timeout?: number;
}

const DEFAULT_SOCKET_CONFIG: SocketConfig = {
  url: process.env.NEXT_PUBLIC_SEARCH_URL || 'ws://localhost:3001',
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  timeout: 10000,
};

const socketRegistry = new Map<string, Socket>();

/**
 * Создает или возвращает существующий сокет
 * @param key - Уникальный ключ для сокета
 * @param config - Конфигурация сокета
 * @returns Socket instance
 */
function createSocket(key: string, config: Partial<SocketConfig> = {}): Socket {
  if (socketRegistry.has(key)) {
    const existingSocket = socketRegistry.get(key)!;

    if (existingSocket.connected) {
      return existingSocket;
    }

    socketRegistry.delete(key);
  }

  const finalConfig = { ...DEFAULT_SOCKET_CONFIG, ...config };

  const socket = io(finalConfig.url, {
    ...finalConfig,
    transports: ['polling', 'websocket'],
  });

  socketRegistry.set(key, socket);

  socket.on('disconnect', () => {
    if (socketRegistry.get(key) === socket) {
      socketRegistry.delete(key);
    }
  });

  return socket;
}

function isSocketAvailable(): boolean {
  return typeof window !== 'undefined';
}

export type { SearchIndex, SocketConfig, Socket };

export { DEFAULT_SOCKET_CONFIG, createSocket, isSocketAvailable };
